import type { FC } from 'react'
import { useEffect } from 'react'
import type { Props } from './types'

export const ScrollToTop: FC<Props> = ({ location, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return children
}
